import { uniqueId } from 'lodash';

// Participant ids come from three unrelated sources (backend registration, expert list and newly
// added guests). They are namespaced so that a guest can never share an id with an expert or with
// an already registered participant, which would make the per-participant email state ambiguous.
export const getRegisteredParticipantId = (participantId) => `registered-${participantId}`;

export const getExpertParticipantId = (expertId) => `expert-${expertId}`;

export const createGuestParticipantId = () => uniqueId('guest-');

export const isPersistedParticipant = (participant) =>
  String(participant?.id || '').startsWith('registered-');
